import { EDIT_EVALUATION_NAME } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (termNumber: string, name: string, token: string) =>
  fetch(EDIT_EVALUATION_NAME(termNumber), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify({ name }),
  }).then(errorHandler)
